// initial state
/* loading */

const state = {
  // loading
  loadingSta: true,
  loadingSum: 0
};

// getters
const getters = {

};

// actions
const actions = {

};

// mutations
const mutations = {
  loadSta(state,item) {
    state.loadingSta = item;
    state.loadingSum++;
  },

  loadRed(state) {
    state.loadingSum--;
    if (state.loadingSum < 1) {
      state.loadingSta = false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/module/loading.js